import React from 'react';
import { get } from 'lodash-es';
import { EditorialModel, buildTypeArticlesPath } from 'client/data/models/editorial';
import { PageModel } from 'client/data/models/page';
import { getTreehouseEligiblePath, TreehouseModel } from 'client/data/models/treehouse';
import { LinkWidgetsModel, getPageLinksPath } from 'client/data/models/link-widgets';
import { ModelPreloader } from 'client/data/luckdragon/redux/model-preloader';
import { getModelState } from 'client/data/luckdragon/model';
import { pageDefinition } from 'site-modules/shared/pages/page';
import { getBreadcrumbSchema } from 'client/seo/schemas/breadcrumbs';
import { getListItemSchema } from 'client/seo/schemas/list';
import { getUserFriendlyTypeName } from 'site-modules/shared/utils/upper-funnel/type-mapping';
import { getEditorialNewsArticleSchema } from 'client/seo/schemas/article';
import { getTypeNewsPageBreadcrumbs } from 'site-modules/editorial/utils/breadcrumbs';
import { updateVehicle } from 'client/actions/vehicle';
import { TypeNews, getHeroImageHref } from './type-news';

const TYPE_NICE_NAME = { ev: 'electric' };

export const pageOptions = {
  name: 'car_news_industry_article_index',
  category: 'car-news',
  preload: (store, props) => {
    const type = get(props, ['match', 'params', 'type'], '');

    const preloader = new ModelPreloader(store);

    preloader.resolve(buildTypeArticlesPath(type), EditorialModel);
    preloader.resolve(getPageLinksPath(), LinkWidgetsModel);

    if (type === 'ev') {
      preloader.resolve(getTreehouseEligiblePath(), TreehouseModel);
    }

    store.dispatch(updateVehicle({ type: { niceName: TYPE_NICE_NAME[type] || type } }));

    return preloader.load().then(modelState => {
      const articles = get(modelState.get(buildTypeArticlesPath(type), EditorialModel), 'results', []);

      const { mobile: isMobile } = store.getState();

      const preloadHeroImageAsset = {
        href: getHeroImageHref({ articles, type, isMobile }),
        as: 'image',
      };

      preloader.set('server.preloadedAssets', PageModel, [preloadHeroImageAsset]);

      return preloader.load();
    });
  },
  seo: (state, props) => {
    const modelState = getModelState(state);
    const pathname = get(props, 'location.pathname');
    const type = get(props, ['match', 'params', 'type'], '');

    const articles = get(modelState.get(buildTypeArticlesPath(type), EditorialModel), 'results', []);

    const titleName = getUserFriendlyTypeName(type);
    const title = `${titleName} News Articles, Reviews, and Insights`;

    return {
      title: `${title} | Edmunds`,
      description: `Read the latest news about ${titleName} vehicles. Edmunds offers exclusive stories, up to date news, photos, and videos.`,
      jsonld: [
        getListItemSchema({
          items: articles.map(({ relativeUrl, title: articleTitle }, ind) => ({
            position: ind + 1,
            name: articleTitle,
            url: `https://www.edmunds.com${relativeUrl}`,
          })),
          name: title,
          pageUrl: `https://www.edmunds.com/car-news/${type}/`,
        }),
        getBreadcrumbSchema(getTypeNewsPageBreadcrumbs(titleName, pathname)),
        ...articles.map(article =>
          getEditorialNewsArticleSchema({ article, author: get(article, ['authors', 0, 'name'], '') })
        ),
      ],
    };
  },
  component: props => <TypeNews {...props} type={get(props, ['match', 'params', 'type'])} />,
};

export default pageDefinition(pageOptions);
